import * as XLSX from 'xlsx';

export const parseExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        // Transform Excel data to API format
        const employeeList = jsonData.map((row) => ({
          employeeId: row.employeeId || row.EmployeeId || row.id || row.Id,
          location: {
            lat: parseFloat(row.lat || row.Lat || row.latitude || row.Latitude),
            lng: parseFloat(row.lng || row.Lng || row.longitude || row.Longitude),
          },
        }));

        resolve(employeeList);
      } catch (error) {
        reject(new Error('Failed to parse Excel file: ' + error.message));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsArrayBuffer(file);
  });
};

export const downloadSampleExcel = () => {
  const sampleData = [
    { employeeId: '1057572', lat: 12.89, lng: 77.5691 },
    { employeeId: '1057518', lat: 12.8792, lng: 77.596 },
    { employeeId: '1056989', lat: 12.97, lng: 77.7068 },
  ];

  const ws = XLSX.utils.json_to_sheet(sampleData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Employees');
  XLSX.writeFile(wb, 'employee_sample.xlsx');
};
